export const env = "prod";
export const URLs = {
  local: "http://localhost:5001/kaching-dd5ed/asia-south1",
  prod: "https://asia-south1-kaching-dd5ed.cloudfunctions.net",
};
export const baseURL = URLs[env];
